import { Component, Input } from '@angular/core';
import {
  DynamicFormControlType,
  DynamicFormField,
} from './dynamic-form.interfaces';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  standalone: false,
})
export class DynamicFormComponent {
  @Input() fields: DynamicFormField[] = [];

  readonly FormControlType = DynamicFormControlType;
}
